var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[_c('message-alert'),_vm._v(" "),(!_vm.isInApp)?_c('navbar'):_vm._e(),_vm._v(" "),_c('v-main',[_c('v-container',[_c('nuxt')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }